import React, { useEffect, useState } from 'react'

import '../sass/components/Fireworks.sass'

const colors = [
    '#e5e4e2', // platinum
    '#f8f8ff', // ghost white
    '#dcdcdc', // gainsboro
    '#c0c0c0', // silver
    '#f0f0f0', // very light gray
]


type SparkProps = {
    x: string
    y: string
    color: string
    delay: string
}

const Spark: React.FC<SparkProps> = ({ x, y, color, delay }) => (
    <div
        className="spark"
        style={{
            backgroundColor: color,
            animationDelay: delay,
            // @ts-ignore
            '--x': x,
            '--y': y,
        } as React.CSSProperties}
    />
)


type BurstProps = {
    top: string
    left: string
}

const Burst: React.FC<BurstProps> = ({ top, left }) => {
    const sparks = Array.from({ length: 20 }, (_, i) => {
        const angle = (Math.PI * 2 * i) / 20
        const distance = 60 + Math.random() * 40
        const x = `${Math.cos(angle) * distance}px`
        const y = `${Math.sin(angle) * distance}px`
        const color = colors[Math.floor(Math.random() * colors.length)]
        const delay = `${Math.random() * 1.5}s`
        return <Spark key={i} x={x} y={y} color={color} delay={delay} />
    })

    return <div className="burst" style={{ top, left }}>{sparks}</div>
}

const Fireworks: React.FC = () => {
    const [bursts, setBursts] = useState<React.ReactElement[]>([])


    useEffect(() => {
        const burstCount = 25 // total bursts per cycle
        const maxDelay = 500 // max delay in ms

        const timers: NodeJS.Timeout[] = []

        for (let i = 0; i < burstCount; i++) {
            const delay = Math.random() * maxDelay
            const timer = setTimeout(() => {
                const top = `${Math.random() * 35}%` // upper 40% of the screen
                const left = `${Math.random() * 100}%`
                setBursts(prev => [
                    ...prev,
                    <Burst key={Date.now() + i} top={top} left={left} />,
                ])
            }, delay)
            timers.push(timer)
        }

        // const interval = setInterval(() => {
        //     setBursts([]) // clear old bursts
        //     timers.forEach(clearTimeout) // clear previous timers
        // }, maxDelay + 500) // reset after each cycle

        // return () => {
        //     clearInterval(interval)
        //     timers.forEach(clearTimeout)
        // }
    }, [])


    return <div className="fireworks-background">{bursts}</div>
}

export default Fireworks
